/**
 * `<select>` nativo con tokens del DS (L-007): accesible, testeable y con selector nativo en tablet.
 * Altura `h-11` (44 px) para uso táctil en sala de ventas.
 */
export const NATIVE_SELECT_CLASS =
  'h-11 w-full rounded-md border border-input bg-background px-3 text-base text-foreground ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 aria-[invalid=true]:border-destructive sm:text-sm';

/** Altura táctil para inputs del flujo del asesor. */
export const TOUCH_INPUT_CLASS = 'h-11 text-base sm:text-sm';

export const SECTION_CARD_CLASS =
  'animate-rise space-y-5 rounded-xl border border-border/70 bg-card p-5 shadow-elegant sm:p-6';

export const EYEBROW_CLASS =
  'text-[0.7rem] font-semibold uppercase tracking-[0.22em] text-brand-gold-dark';
